import React from 'react';
import Syndicate from '../Auth/utils/Syndicate';
import styled from 'styled-components';
import { PageHeaderDivider, PageTitle } from '../../components/PageHeader';
import { useAppSelector } from '../../redux/hooks';
import {
  selectAuthCapricaGitSha,
  selectAuthUpdateAvailable,
} from '../../redux/selectors/auth';
import { LayoutMainContainer } from '../../Layout/LayoutUI';

const ContentTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  color: #333333;

  margin-bottom: 8px;
`;

const Content = styled.div`
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  color: #8a94bd;
`;

export default () => {
  const { kobolGitSha } = Syndicate.getData();
  const capricaGitSha = useAppSelector(selectAuthCapricaGitSha);
  const updateAvailable = useAppSelector(selectAuthUpdateAvailable);

  return (
    <LayoutMainContainer>
      <PageTitle title={'System'} />
      <PageHeaderDivider />
      <ContentTitle>Build</ContentTitle>
      <Content>
        k#{kobolGitSha}, c#{capricaGitSha || 'N/A'}
        {updateAvailable && (
          <span className={'ui orange label'}>Update Available</span>
        )}
      </Content>
    </LayoutMainContainer>
  );
};
